
import {
    FETCH_TASKS_REQUEST,
    FETCH_TASKS_SUCCESS,
    FETCH_TASKS_FAILURE,
    CREATE_TASK_REQUEST,
    CREATE_TASK_SUCCESS,
    CREATE_TASK_FAILURE,
    DELETE_TASK_REQUEST,
    DELETE_TASK_SUCCESS,
    DELETE_TASK_FAILURE,
    UPDATE_TASK_REQUEST,
    UPDATE_TASK_SUCCESS,
    UPDATE_TASK_FAILURE,
} from '../actions/taskActions';

const taskInitialState = {
    tasks: [],
    loading: false,
    error: false,
};

const taskReducer = (state = taskInitialState, action) => {
    switch (action.type) {
        case FETCH_TASKS_REQUEST:
            return { ...state, loading: true };
        case FETCH_TASKS_SUCCESS:
            return { ...state, loading: false, tasks: action.payload };
        case FETCH_TASKS_FAILURE:
            return { ...state, loading: false, error: true };
        case CREATE_TASK_REQUEST:
            return { ...state, loading: true };
        case CREATE_TASK_SUCCESS:
            return { ...state, loading: false, tasks: [...state.tasks, action.payload] };
        case CREATE_TASK_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case DELETE_TASK_REQUEST:
            return { ...state, loading: true };
        case DELETE_TASK_SUCCESS:
            return {
                ...state,
                loading: false,
                tasks: state.tasks.filter(task => task.id !== action.payload),
            };
        case DELETE_TASK_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case UPDATE_TASK_REQUEST:
            return { ...state, loading: true };
        case UPDATE_TASK_SUCCESS:
            return {
                ...state,
                loading: false,
                tasks: state.tasks.map(task =>
                    task.id === action.payload.id ? action.payload : task
                ),
            };
        case UPDATE_TASK_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default taskReducer;
